// import stringToHTML helper functions
import { stringToHTML } from '../../scripts/stringToHTML.js';

// import section style
import './style.scss';

// import back to top template
const _template = require('./tmpl.html?template').default,
  _template_content = stringToHTML(_template).firstChild;

// Fix modals fixed positioning
// check if has modals
const modals = _template_content.querySelectorAll('.modal');
if (modals.length > 0)
  modals.forEach((modal) => {
    // Remove the div from its current position
    modal.parentNode.removeChild(modal);

    // Append the div to the end of the body tag
    document.body.appendChild(modal);
  });

// Back to top
const backToTopButton = _template_content.querySelector(
  '[data-action="backToTop"]'
);
// View/Hide action
window.addEventListener('scroll', function () {
  window.scrollY > 300
    ? backToTopButton.classList.add('scrolled')
    : backToTopButton.classList.remove('scrolled');
});
// Scroll to top
backToTopButton.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
});

// Add section to body
document.body.append(_template_content);

// Support Modal
document.addEventListener('DOMContentLoaded', () => {
  // Get modal
  const modal = document.querySelector('#supportModal');

  // Reset modal
  modal.addEventListener('show.bs.modal', (event) => {
    modal.setAttribute('data-view', 'start');
  });

  // Get modal actions
  const startAction = modal.querySelector('button[data-view="start"]'),
    submitAction = modal.querySelector('button[data-view="form"]'),
    backAction = modal.querySelector('button.btn-back');

  // View form on click request contact
  startAction.addEventListener('click', () => {
    modal.setAttribute('data-view', 'form');
  });

  // View sent state on click submit
  submitAction.addEventListener('click', () => {
    modal.setAttribute('data-view', 'sent');
  });

  // Back action
  backAction.addEventListener('click', () => {
    modal.setAttribute('data-view', 'start');
  });
});
